<template>
    <layout-portal>
		<section class="contacts-page">
			<div class="row no-gutters">
                <div class="col-sm-12">
                        <div class="row mb-3">
                            <div class="col-sm-12">
                                <h1 class="content-title">{{ this.pageTitle }}</h1>
                            </div>
                        </div>
                        <div class="row no-gutters">
                        	<div class="col-12 col-md-6 pr-md-5">
	                        	<div class="pb-3 pb-sm-5 content-text" v-html="$sanitize(address)"></div>
	                        	<div class="row contacts">
	                        		<div class="col" v-if="phone">
	                        			<p class="text-medium">{{ $t(`${pageID}.model.phone`) }}</p>
										<p class="">
											<a class="text-strong text-nowrap" :href="`${phoneHref}`">{{ phone }}</a>
										</p>
	                        		</div>
                                    <div class="col" v-if="coordinates">
                                        <p class="text-medium">{{ $t(`${pageID}.model.coordinates`) }}</p>
                                        <p class="text-strong">
											<template v-if="coordinatesLink">
												<a class="text-nowrap"
													:href="coordinatesLink"
													target="_blank">
													{{ coordinatesText }}
												</a>
											</template>
											<template v-else>
												{{ coordinatesText }}
											</template>
										</p>
                                    </div>
	                        		<div class="col" v-if="email">
	                        			<p class="text-medium">{{ $t(`${pageID}.model.email`) }}</p>
										<p class="">
											<a class="text-strong text-nowrap" :href="`${emailHref}`">{{ email }}</a>
										</p>
	                        		</div>

	                        	</div>
	                        </div>
                        	<div class="col-12 col-md-6 pl-md-5 pr-md-4">
                    			<form autocomplete="off" @submit.prevent="send" method="post" data-vv-scope="form">
					                <div class="row">
					                    <div class="col">
					                        <MaterialInput
												type="text"
												class="city-form-group city-bg mt-4 mt-sm-0"
												id="input-name"
												name="name"
												v-model.trim="form.name"
												v-validate="'required|min:3|max:255'"
												:inputClasses="[{'is-invalid': $root.fnHasError('form.name',this)}]"
												:error="errors.first('form.name')">
												{{ $t(`${pageID}.form.name`) }}
											</MaterialInput>
					                    </div>
					                </div>
					                <div class="row">
					                    <div class="col">
					                        <MaterialInput
												type="text"
												class="city-form-group city-bg"
												id="input-email"
												name="email"
												v-model.trim="form.email"
												v-validate="'required|email|max:255'"
												:inputClasses="[{'is-invalid': $root.fnHasError('form.email',this)}]"
												:error="errors.first('form.email')">
												{{ $t(`${pageID}.form.email`) }}
											</MaterialInput>
					                    </div>
					                </div>
					                <div class="row">
					                    <div class="col">
					                    	<MaterialInput
												type="text"
												class="city-form-group city-bg"
												id="input-subject" name="subject"
												v-model.trim="form.subject"
												v-validate="'required|min:3|max:255'"
												:inputClasses="[{'is-invalid': $root.fnHasError('form.subject',this)}]"
												:error="errors.first('form.subject')">
												{{ $t(`${pageID}.form.subject`) }}
											</MaterialInput>
					                    </div>
					                </div>
					                <div class="row">
					                    <div class="col">
					                        <div class="form-group city-form-group city-bg">
												<MaterialTextarea
													:disabled="readonlyFormItem"
													class="city-form-group city-bg"
													id="input-message"
													name="message"
													v-model.trim="form.message"
													:rows="8"
													v-validate="'required|min:20'"
													:inputClasses="[{'is-invalid': fnHasError('message') }]"
													:error="fnFirstError('message')">
													{{ $t(`${pageID}.form.message`) }}
												</MaterialTextarea>
					                        </div>
					                    </div>
					                </div>
					                <div class="row">
							            <div class="col-9 col-sm-auto mx-auto">
						                    <div class="row my-3 my-sm-4">
						                        <div class="col-sm-auto pb-3">
						                            <button class="btn btn-main btn-rounded btn-md btn-block z-depth-0"
														type="submit"
														:disabled="isDisabled">
														{{ $t(`${pageID}.buttons.send`) }}
													</button>
						                        </div>
						                    </div>
						                </div>
						            </div>
								</form>
                        	</div>
                        </div>
				</div>
			</div>
		</section>
    </layout-portal>
</template>

<script>
    import mixin from '../mixin'
	import { isEmail } from '@config/utils';

    export default {
	 	mixins: [mixin],
    	data() {
            return {
                pageID: 'contact',
                form: {
                    name: null,
                    email: null,
                    subject: null,
                    message: null,
                },
				// Autorizo a utilização e o armazenamento dos meus dados de acordo com o Regulamento Geral da Protecção de Dados *
				// A Instituição compromete-se a garantir a segurança e confidencialidade dos seus dados pessoais. No cumprimento do Regulamento de Proteção de Dados (UE) 2016/679, a informação acima inserida servirá única e exclusivamente para o propósito descrito: responder ou fornecer informação sobre a questão ou pedido solicitado neste formulário de contacto. Adicionalmente ao premir o botão enviar, o utilizador, na qualidade de dono da informação, concede à nossa Instituição o direito de processamento dos dados para os fins acima indicados. Informamos ainda que estes dados: não serão guardados na base de dados deste website; não serão usados para outros fins; não serão transmitidos a terceiros. Ficarão apenas no formato de mail no endereço identificado como E-Mail 1 nos contactos presentes nesta página. Qualquer pedido de atualização ou remoção da informação capaz de o identificar, pode ser requerida pelo contacto direto à Instituição ou usando o formulário de contacto deste site, indicando no assunto alteração ou remoção de dados pessoais. A nossa instituição compromete-se a remover a sua mensagem logo que o processo de esclarecimento esteja concluído ou após 90 dias a contar do seu último contacto.
            }
        },
		computed: {
			contactConfig() {
                return this.$store.getters.platformContactConfig ?? {};
            },
			address() {
				return this.contactConfig?.address ?? null;
			},
			email() {
				return this.contactConfig?.email ?? null;
			},
			emailHref() {
				return this.contactHref(this.email);
			},
			phone() {
				return this.contactConfig?.phone ?? null;
			},
			phoneHref() {
				return this.contactHref(this.phone);
			},
			coordinates() {
				return this.contactConfig?.coordinates ?? null;
			},
			coordinatesLink() {
				return this.contactConfig?.coordinates_link ?? null;
			},
			coordinatesText() {
				// let coordinates = this.coordinates;
				// return coordinates ? coordinates.replace(/\s/g, '').replace(',', ', ') : null;
				return this.coordinates;
			},
		},
        methods: {
			contactHref(val) {
				if(!val) return null;

				if(isEmail(val)) {
					return `mailto:${ val }`;
				}else{
					return `tel:${ val.replace(/[^\d\+]+/g,'').replace(/(.)\++/g,"$1") }`;
				}
			},
            reset() {
                this.$validator.pause();
                Object.assign(this.$data.form, this.$options.data().form);
                this.$validator.reset();
                this.$validator.resume();
            },
			send() {
				this.clearMessages();
				this.$validator.validateAll('form')
				.then(result => {
					if(!result) {
						this.showError(`global.msg.error.form`, this.pageTitle);
						return;
					}

					this.$http.post(this.url.sendMessage, this.form,)
					.then(res => {
						this.reset();
						this.showMessage(res.data.data);
					})
					.catch(error => {
						this.showHttpError(error);
					})
				});
			}
		}
    }

</script>

<style lang="scss">
@import "@styles/_theme.scss";

    .contacts, .contacts a {
		color: $body-color!important;
		font-family: $city-bold-font-family !important;
    }
</style>